export const TaskType = {
    EPIC: "EPIC",
    STORY: "STORY",
    TASK: "TASK",
    WORKDAY: "WORKDAY",
  }
  
  export const TaskStatus = {
    BACKLOG: "BACKLOG",
    TODO: "TODO",
    IN_PROGRESS: "IN_PROGRESS",
    DONE: "DONE",
  }
  
  